import { useState } from 'react'

import './index.scss'
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons'
import {
  faBars,
  faBriefcase,
  faEnvelope,
  faHome,
  faLaptopCode,
  faScrewdriverWrench,
  faTimes,
  faUser,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link, NavLink } from 'react-router-dom'


const Sidebar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false)
  }

  return (
    <>
      {/* Hamburger menu button for mobile */}
      <button 
        className="hamburger-menu" 
        onClick={toggleMobileMenu}
        aria-label="Toggle navigation menu"
      >
        <FontAwesomeIcon icon={isMobileMenuOpen ? faTimes : faBars} />
      </button>

      {/* Overlay for mobile menu */}
      {isMobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={closeMobileMenu}></div>
      )}

      <div className={`nav-bar ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
        <Link className="logo" to="/">
          <span className="logo-text">T</span>
          <span className="sub-logo-text">Touheed</span>
        </Link>
        <nav>
          <NavLink end to="/" aria-label="Home" onClick={closeMobileMenu}>
            <FontAwesomeIcon icon={faHome} />
          </NavLink>
          <NavLink
            className="about-link"
            to="/about"
            aria-label="About"
            onClick={closeMobileMenu}
          >
            <FontAwesomeIcon icon={faUser} />
          </NavLink>

          <NavLink
            className="experience-link"
            to="/experience"
            aria-label="Experience"
            onClick={closeMobileMenu}
          >
            <FontAwesomeIcon icon={faBriefcase} />
          </NavLink>

          <NavLink
            className="projects-link"
            to="/projects"
            aria-label="Projects"
            onClick={closeMobileMenu}
          >
            <FontAwesomeIcon icon={faLaptopCode} />
          </NavLink>

          <NavLink
            className="skills-link"
            to="/skills"
            aria-label="Skills"
            onClick={closeMobileMenu}
          >
            <FontAwesomeIcon icon={faScrewdriverWrench} />
          </NavLink>

          <NavLink
            className="contact-link"
            to="/contact"
            aria-label="Contact"
            onClick={closeMobileMenu}
          >
            <FontAwesomeIcon icon={faEnvelope} />
          </NavLink>
        </nav>
        <ul>
          <li>
            <a
              href="https://www.linkedin.com/in/touheedkhan/"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn profile"
            >
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
          </li>
          <li>
            <a
              href="https://github.com/touheedk"
              target="_blank"
              rel="noreferrer"
              aria-label="GitHub profile"
            >
              <FontAwesomeIcon icon={faGithub} />
            </a>
          </li>
        </ul>
      </div>
    </>
  )
}

export default Sidebar
